import { useCallback } from "react";

import { useLazyGetTransactionQuery } from "../../../services";
import { FetchTransactionDetails } from "./types";

// One-shot prefill read: unsubscribe once the row is in hand so it isn't kept cached.
export const useTransactionDetails = (): FetchTransactionDetails => {
  const [fetchTransaction] = useLazyGetTransactionQuery();

  return useCallback(
    async (transactionId: number) => {
      const request = fetchTransaction(transactionId);
      try {
        return await request.unwrap();
      } finally {
        request.unsubscribe();
      }
    },
    [fetchTransaction],
  );
};
